/*
 * "Add a gift message" in the product page's sticky bar.
 *
 * A PROXY for the real <giftnote-button>, not a second copy of it. The app's
 * custom element owns a shadow root and writes cart attributes; mounting a
 * second instance would put two of them on one page competing over the same
 * state. This scrolls the real one into view and clicks it.
 *
 * Hidden by default in the markup and only revealed once a Giftnote widget is
 * actually found, so the utility products (gift wrapping, the surcharge item)
 * never show a control that leads nowhere — the failure mode is an absent
 * button rather than a dead one.
 */
(() => {
  'use strict';

  const proxy = document.querySelector('[data-gn-sticky-gift]');
  if (!proxy) return;

  function widget() {
    const el = document.querySelector('giftnote-button');
    if (!el) return null;
    // Present but unrendered is the same as absent for our purposes: the app
    // hydrates ~1.1s in, and clicking a 0x0 host does nothing.
    const r = el.getBoundingClientRect();
    return r.width > 4 && r.height > 4 ? el : null;
  }

  function reveal() {
    if (!widget()) return false;
    proxy.hidden = false;
    return true;
  }

  // Poll briefly rather than assume: the widget is not in the DOM at parse time.
  let tries = 0;
  const timer = setInterval(() => {
    if (reveal() || ++tries > 40) clearInterval(timer);
  }, 150);

  proxy.addEventListener('click', () => {
    const el = widget();
    if (!el) return;
    el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    // Let the smooth scroll finish before clicking, or the modal opens against
    // a page that is still moving underneath it.
    setTimeout(() => el.click(), 380);
  });
})();
